import { useMatchDetailsStore } from "../../stores/StoreContext";
import { ComparisonSection } from "../matchDetails/components/ComparisonSection";
import { MatchStats } from "../matchDetails/components/MatchStats";
import { MatchStatsLoader } from "../matchDetails/components/MatchStatsLoader";
import { ScoreSection } from "../matchDetails/components/ScoreSection";
import { ShotCoverageSection } from "../matchDetails/components/ShotCoverageSection";
import "./UltraPromo.css";
import { useParams } from "react-router-dom";
import UltraPromoHeader from "../../assets/ultra_promo_header.png";
import { useEffect } from "react";

export const UltraPromo = () => {
  const { id } = useParams();
  const matchDetailsStore = useMatchDetailsStore();
  matchDetailsStore.setMatchGuid(id ?? "");

  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "apple-itunes-app";
    meta.content = `app-id=${process.env.REACT_APP_IOS_BUNDLE_ID}`;
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <>
      <div
        style={{
          paddingBottom: 30,
          display: "flex",
          flexDirection: "column",
        }}>
        <div style={{ height: 0 }} />
        <div
          style={{
            maxWidth: "450px",
            width: "100%",
            justifyContent: "center",
            alignSelf: "center",
            margin: "0 auto",
          }}>
          <div
            onClick={() => {
              window.open(
                "https://ultrapadelclub.com/ultra-ai-app-download",
                "_blank"
              );
            }}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 25,
              marginBottom: 25,
            }}>
            <img
              src={UltraPromoHeader}
              alt=""
              style={{
                width: 111,
                height: 65,
                objectFit: "contain",
              }}
            />
          </div>
          <ScoreSection />
          <MatchStats />
          <ComparisonSection />
          <ShotCoverageSection />
        </div>
        <MatchStatsLoader />
      </div>
    </>
  );
};
